import React from 'react';
import Login from './Login';
import { routePaths } from '../../routePaths';
import { translate } from '../../utils';

const LoginRoute = {
    exact: true,
    path: routePaths.login,
    title: translate('Login'),
    component: () => <Login />,
};

export default LoginRoute;
